import { cloneDeep } from 'lodash';

import {
  calculateCartTotal,
  countCartItems,
} from '@/utils/helper';
import {
  CLEAR_CART_ITEMS,
  CLEAR_CART_ITEMS_DONE,
  MODIFY_CART_ITEM,
  REMOVE_CART_ITEM,
  SET_CART_ITEM,
  SET_CART,
  SET_CART_DONE,
} from './constants';

export default {
  [CLEAR_CART_ITEMS]({ commit }) {
    const defaultCart = {
      count: 0,
      items: [],
      menu_id: null,
      total: 0,
    };

    localStorage.setItem('cart', JSON.stringify(defaultCart));
    commit(CLEAR_CART_ITEMS_DONE, defaultCart);
  },
  [MODIFY_CART_ITEM]({ dispatch, state }, { itemIndex, ...payload }) {
    const cart = cloneDeep(state.cart);
    const items = cart?.items || [];
    const item = items[itemIndex] || {};
    const newItem = { ...item, ...payload };
    const { count, subtotal } = newItem;

    cart.items[itemIndex] = { ...newItem, total: count * subtotal };
    dispatch(SET_CART, cart);
  },
  [REMOVE_CART_ITEM]({ dispatch, state }, index) {
    const cart = cloneDeep(state.cart);
    cart.items.splice(index, 1);

    if (!cart?.items?.length) {
      dispatch(CLEAR_CART_ITEMS);
    } else {
      dispatch(SET_CART, cart);
    }
  },
  [SET_CART_ITEM]({ dispatch, state }, {
    count,
    itemIndex,
    itemName,
    menuId,
    price = 0,
    share,
    subtotal = 0,
    ...props
  }) {
    const cart = cloneDeep(state.cart);
    const item = {
      ...props,
      count,
      index: itemIndex,
      name: itemName,
      price: price || 0,
      subtotal,
      total: count * subtotal,
    };

    cart.items.push(item);
    cart.menu_id = menuId;
    cart.share_key = share;

    dispatch(SET_CART, cart);
  },
  [SET_CART]({ commit }, payload) {
    const cart = cloneDeep(payload);

    const items = cart?.items || [];
    cart.count = countCartItems(items);
    cart.total = calculateCartTotal(items);

    localStorage.setItem('cart', JSON.stringify(cart));
    commit(SET_CART_DONE, cart);
  },
};
